<button class="lx-btn lx-btn-text"
        [disabled]="disabled"
        (click)="onClick()">
  <i class="lx-icon lx-download"></i>
  Download CSV
</button>